<template>
    <Upload :action="attrs.api" :headers="headers" :on-success="handleSuccess" :data="fromdata" ref="upload"
        style="display:inline-block;">
        <Button icon="ios-cloud-upload-outline">{{ attrs.title }}</Button>
    </Upload>
</template>
<script>
import { mapGetters } from 'Vuex'
export default {
    name: 'LyFileUpload',
    props: {
        attrs: {
            type: Object,
            default: _ => new Object()
        }
    },
    computed: {
        ...mapGetters(['tokon', 'hubbleId', 'hlftokon'])
    },
    data() {
        return {
            fromdata: {}, // 设置上传对象的其他参数
            headers: {} // 设置上传的请求头部
        }
    },
    mounted() {
        this.headers = {
            Authorization: this.tokon
        }
        if (this.hubbleId) {
            this.headers['Hubble-Id'] = this.hubbleId
        }
        if (this.hlftokon) {
            this.headers['Authorization91'] = this.hlftokon
        }
        //存在需要传参数的情况下 数据在路由上
        if (this.attrs.fromfiled) {
            this.fromdata[this.attrs.fromfiled] = this.$route.params[this.attrs.fromfiled]
        }
    },
    methods: {
        /**
         * 上传成功后的处理
         */
        handleSuccess(res, file) {
            if (res.status == 200) {
                this.$Message.success('上传成功')
            } else {
                console.log('msg',)
                this.$Message.error({ content: res.msg, duration: 5 })
            }
            this.$refs.upload.clearFiles()
        }
    }
}
</script>



// WEBPACK FOOTER //
// ../projectCore/src/components/file-upload/src/index.vue